module.exports = __webpack_public_path__ + "static/media/ic_merikontti_a.f4a2a6c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/map/images/ic_merikontti_a.svg
// module id = 1185
// module chunks = 0